import React, { useState } from "react";

export default function ExamPills({ exams=[] }) {
  if (!exams || exams.length===0) return <span style={{color:"var(--t3)",fontSize:11}}>—</span>;
  return (
    <div style={{display:"flex",alignItems:"center",gap:4}}>
      <span className="tc">{exams[0]}</span>
      {exams.length > 1 && (
        <span style={{fontSize:10,fontWeight:700,color:"var(--p)",background:"var(--pm)",padding:"2px 5px",borderRadius:4}}>+{exams.length-1}</span>
      )}
    </div>
  );
}